import { IParamsGeneralInfo } from 'app/api/dashboard/model'

export const DashboardKeys = {
  allGeneralInfo: ['GeneralInfo'] as const,
  generalInfos: () => [...DashboardKeys.allGeneralInfo, 'GeneralInfo'] as const,
  generalInfo: (filters?: IParamsGeneralInfo) =>
    [...DashboardKeys.generalInfos(), { filters }] as const,
}
